export const DragAndDropDefaultClassesMock = ['drag-and-drop'];
export const DragAndDropDefaultPropsMock = {};
